import { DotsThreeVertical, Trash } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import { Dialog, DialogContent } from "common/components/ui/Dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import type { LinkedInProfile } from "common/types";

import useBlacklistMutations from "../../../datahooks/useBlacklistMutations";
import RemoveFromBlacklist from "../RemoveFromBlacklist";

import type { Company } from "../../../types";

interface BlacklistRowMenuProps {
  item: Company | LinkedInProfile;
}

export default function BlacklistRowMenu({ item }: BlacklistRowMenuProps) {
  const { removeFromBlacklist, isRemovingFromBlacklist } =
    useBlacklistMutations();

  const [isRemoveOpen, setIsRemoveOpen] = useState(false);

  const isCompanyBlacklist = "logo_url" in item;

  function onRemove() {
    removeFromBlacklist(
      isCompanyBlacklist ? { companyUrn: item.urn } : { accountUrn: item.urn },
    ).then(() => {
      setIsRemoveOpen(false);
    });
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="secondary-black"
            intent="iconOnly"
            className="ml-auto"
            size="sm"
            onClick={(e) => e.stopPropagation()}
          >
            <DotsThreeVertical />
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end" size="sm">
          <DropdownMenuList>
            <DropdownMenuItem
              onSelect={() => setIsRemoveOpen(true)}
              variant="danger"
            >
              <Trash />
              Remove from blacklist
            </DropdownMenuItem>
          </DropdownMenuList>
        </DropdownMenuContent>
      </DropdownMenu>
      <Dialog open={isRemoveOpen} onOpenChange={setIsRemoveOpen}>
        <DialogContent>
          <RemoveFromBlacklist
            selectedItems={[item]}
            onBack={() => setIsRemoveOpen(false)}
            onRemove={onRemove}
            blacklistType={isCompanyBlacklist ? "companies" : "accounts"}
            isLoading={isRemovingFromBlacklist}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
